
import { ExtraFieldTimeConfig } from "@/models/dossier-configs/extra-field-time-config";
import { DossierConfigService } from "@/services/dossier-config-service";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppExtraFieldBaseOptions from "./ExtraFieldBaseOptions.vue";
import { ExtraFieldsType } from "@/utils/models/extra-fields";

export default Vue.extend({
	data(){
		return {
			config: new ExtraFieldTimeConfig(),
			langs: DossierConfigService.getLanguages().LanguageNames
		};
	},
	props: {
		value: {
			type: Object as ()=>ExtraFieldTimeConfig,
			required: true
		},
		optionsIndex: {
			type: Number,
			required: true
		},
		extraFieldsType: {
			type: String as ()=>ExtraFieldsType,
			required: true
		}
	},
	computed: {
		title():TranslateResult{
			return this.$ct("extra-field-time-options", {index: this.optionsIndex});
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.config = new ExtraFieldTimeConfig(this.value);
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("input", this.config);
			this.close();
		}
	},
	components: {
		AppExtraFieldBaseOptions
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
